import TransactionSkeleton from './TransactionListSkeleton';

export default TransactionSkeleton;
